'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var flags = require('../../../data/flags.js');
var flags_2x = require('./flags@2x.png.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var DEFAULT_FLAG = 'ww'; // worldwide flag

var Flag = function Flag(_ref) {
  var flag = _ref.flag,
      className = _ref.className;
  var gotFlag = flags.indexOf(flag.toLowerCase()) >= 0;
  var code = gotFlag ? flag : DEFAULT_FLAG;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    style: {
      backgroundImage: "url(".concat(flags_2x, ")")
    },
    className: "flag flag-".concat(code, " ").concat(className),
    title: code
  });
};

Flag.propTypes = {
  flag: PropTypes__default['default'].string,
  className: PropTypes__default['default'].string
};
Flag.defaultProps = {
  flag: 'es',
  className: ''
};

module.exports = Flag;
